module.exports = __webpack_public_path__ + "static/img/start.1aa554a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/start.png
// module id = Kibh
// module chunks = 0